import R from 'ramda';
import _ from 'lodash';
import React, { Component } from 'react';
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  Radio,
  Checkbox,
} from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from '../ContractBlock/Contents/Payments';
import Select from '../Select';
import { getStringFromArray } from '../../utils';
import ChangeRequestsView from '../Deals/DealEditPages/ChangeRequestsView';

export default class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adjust: undefined,
      changes: {
        block: null,
        amount: '',
        day: '',
        amount1: '',
        amount2: '',
        percentage: '',
        statutoryPercentage: '',
      },
    };
  }

  getOwnershipBlock = () => {
    const contractBlock = _.find(
      this.props.contractBlocks,
      (block) => block.name === 'Ownership'
    );
    return _.find(
      this.props.dealBlocks,
      (block) => block.id === contractBlock.id
    );
  };

  options = () => ({
    // OptionA
    paidType: this.state.changes.paidType,
    feeType: this.state.changes.feeType,
    scheduleType: this.state.changes.scheduleType,
    paySchedule: this.state.changes.paySchedule,
    amount: this.state.changes.amount,
    day: this.state.changes.day,
    amount1: this.state.changes.amount1,
    amount2: this.state.changes.amount2,
    // OptionsB
    percentage: this.state.changes.percentage,
    sales: this.state.changes.sales,
    performances: this.state.changes.performances,
    licenses: this.state.changes.licenses,
    any: this.state.changes.any,
    period: this.state.changes.period,
    periodDay: this.state.changes.periodDay,
    // OptionC
    auditType: this.state.changes.auditType,
    statutoryPercentage: this.state.changes.statutoryPercentage,
    ownershipBlock: this.getOwnershipBlock(),
    dealType: 'edit',
  });

  componentDidMount() {
    if (this.props.dealBlocks) {
      this.getBlockChanges(this.props.dealBlocks);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dealBlocks) {
      this.getBlockChanges(nextProps.dealBlocks);
    }
  }

  getBlockChanges(dealBlocks) {
    const block = R.find(R.propEq('id', this.props.block.id))(dealBlocks);
    if (block) {
      const ownershipContractBlock = R.find(R.propEq('name', 'Ownership'))(
        this.props.contractBlocks
      );
      const paymentContractBlock = R.find(R.propEq('name', 'Payments'))(
        this.props.contractBlocks
      );

      this.setState({ changes: block.changes || {} });
      if (
        ownershipContractBlock.options.composition === 1 &&
        paymentContractBlock.options.statutoryPercentage === ''
      ) {
        this.setState({ adjust: block.changes ? true : undefined });
      } else {
        this.setState({
          adjust: block.accept
            ? !block.accept
            : block.changes
            ? true
            : undefined,
        });
      }
    }
    this.setState({ block });
  }

  handleAdjust(adjust) {
    this.setState({ adjust });
    if (!adjust) {
      this.props.removeBlockChanges(this.props.block.id);
    }
  }

  handleContent(field, value) {
    if (
      (field === 'percentage' || field === 'statutoryPercentage') &&
      value > 100
    ) {
      return;
    }
    const options = this.options();
    options[field] = value;

    if ((field === 'amount1' || field === 'amount2') && value !== '') {
      options['paySchedule'] = 1;
      options['day'] = '';
      options['scheduleType'] = '';
    }

    if ((field === 'day' || field === 'scheduleType') && value !== '') {
      options['paySchedule'] = 0;
      options['amount1'] = '';
      options['amount2'] = '';
    }

    if (field === 'paySchedule') {
      if (value === 0) {
        options['amount1'] = '';
        options['amount2'] = '';
      } else if (value === 1) {
        options['day'] = '';
        options['scheduleType'] = '';
      }
    }

    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      ...getContent(options),
    });
  }

  renderAdjust() {
    const { adjust, changes } = this.state;
    const ownershipBlock = this.getOwnershipBlock();
    let ownershipBlockChanges = ownershipBlock ? ownershipBlock.changes : null;
    if (!ownershipBlockChanges) {
      const contractBlock = _.find(
        this.props.contractBlocks,
        (block) => block.name === 'Ownership'
      );
      const originOwnershipBlock = _.find(
        this.props.agreementContractBlocks,
        (block) => block.contract_block === contractBlock.id
      );
      ownershipBlockChanges = JSON.parse(originOwnershipBlock.options);
    }

    if (adjust === true) {
      return (
        <div className="inner-content">
          <FormGroup className="answer">
            <Radio
              name="paidType"
              checked={changes.paidType === 0}
              readOnly
              onClick={(e) => this.handleContent('paidType', 0)}
            >
              The Producer will be paid a fee and will not receive a royalty.
            </Radio>
            {changes.paidType === 0 && (
              <ul className="sub-answer">
                <li>
                  <FormGroup>
                    The Producer will be paid a rate of $&nbsp;
                    <FormControl
                      type="number"
                      className="input-sm"
                      placeholder="$"
                      value={changes.amount}
                      onChange={(e) =>
                        this.handleContent('amount', e.target.value)
                      }
                    />
                    &nbsp;&nbsp;
                    <Select
                      className="select-mini"
                      value={changes.feeType}
                      onChange={(e) =>
                        this.handleContent('feeType', e.target.value)
                      }
                    >
                      <option value="">select</option>
                      <option value="perHour">per hour</option>
                      <option value="flatFee">in total</option>
                    </Select>
                  </FormGroup>
                  <div className="indent-style">
                    <FormGroup>
                      <Radio
                        name="paySchedule"
                        checked={changes.paySchedule === 0}
                        readOnly
                        onClick={(e) => this.handleContent('paySchedule', 0)}
                      >
                        The Producer will be paid &nbsp;
                        <FormControl
                          type="number"
                          className="input-sm"
                          placeholder="#"
                          value={changes.day}
                          onChange={(e) =>
                            this.handleContent('day', e.target.value)
                          }
                        />
                        &nbsp; days &nbsp;
                        <Select
                          className="select-mini"
                          value={changes.scheduleType}
                          onChange={(e) =>
                            this.handleContent('scheduleType', e.target.value)
                          }
                        >
                          <option value="">select</option>
                          <option value="execution">
                            following the full execution of this agreement
                          </option>
                          <option value="completion">
                            following the completion and delivery of the
                            services
                          </option>
                        </Select>
                      </Radio>
                      <Radio
                        name="paySchedule"
                        checked={changes.paySchedule === 1}
                        readOnly
                        onClick={(e) => this.handleContent('paySchedule', 1)}
                      >
                        The Producer will be paid $&nbsp;
                        <FormControl
                          type="number"
                          className="input-sm"
                          placeholder="$"
                          value={changes.amount1}
                          onChange={(e) =>
                            this.handleContent('amount1', e.target.value)
                          }
                        />{' '}
                        &nbsp;following full execution of this agreement and the
                        balance $&nbsp;
                        <FormControl
                          type="number"
                          className="input-sm"
                          placeholder="$"
                          value={changes.amount2}
                          onChange={(e) =>
                            this.handleContent('amount2', e.target.value)
                          }
                        />{' '}
                        &nbsp;following the completion and delivery of the
                        services&nbsp;
                      </Radio>
                    </FormGroup>
                  </div>
                </li>
              </ul>
            )}

            <Radio
              name="paidType"
              checked={changes.paidType === 1}
              readOnly
              onClick={(e) => this.handleContent('paidType', 1)}
            >
              The Producer will be paid a fee and will receive a royalty of net
              receipts.
            </Radio>
            {changes.paidType === 1 && (
              <ul className="sub-answer">
                <li>
                  <FormGroup>
                    The Producer will be paid a rate of $&nbsp;
                    <FormControl
                      type="number"
                      className="input-sm"
                      placeholder="$"
                      value={changes.amount}
                      onChange={(e) =>
                        this.handleContent('amount', e.target.value)
                      }
                    />
                    &nbsp;&nbsp;
                    <Select
                      className="select-mini"
                      value={changes.feeType}
                      onChange={(e) =>
                        this.handleContent('feeType', e.target.value)
                      }
                    >
                      <option value="">select</option>
                      <option value="perHour">per hour</option>
                      <option value="flatFee">in total</option>
                    </Select>
                  </FormGroup>
                  <div className="indent-style">
                    <FormGroup>
                      <Radio
                        name="paySchedule"
                        checked={changes.paySchedule === 0}
                        readOnly
                        onClick={(e) => this.handleContent('paySchedule', 0)}
                      >
                        The Producer will be paid &nbsp;
                        <FormControl
                          type="number"
                          className="input-sm"
                          placeholder="#"
                          value={changes.day}
                          onChange={(e) =>
                            this.handleContent('day', e.target.value)
                          }
                        />
                        &nbsp; days &nbsp;
                        <Select
                          className="select-mini"
                          value={changes.scheduleType}
                          onChange={(e) =>
                            this.handleContent('scheduleType', e.target.value)
                          }
                        >
                          <option value="">select</option>
                          <option value="execution">
                            following the full execution of this agreement
                          </option>
                          <option value="completion">
                            following the completion and delivery of the
                            services
                          </option>
                        </Select>
                      </Radio>
                      <Radio
                        name="paySchedule"
                        checked={changes.paySchedule === 1}
                        readOnly
                        onClick={(e) => this.handleContent('paySchedule', 1)}
                      >
                        The Producer will be paid $&nbsp;
                        <FormControl
                          type="number"
                          className="input-sm"
                          placeholder="$"
                          value={changes.amount1}
                          onChange={(e) =>
                            this.handleContent('amount1', e.target.value)
                          }
                        />{' '}
                        &nbsp;following full execution of this agreement and the
                        balance $&nbsp;
                        <FormControl
                          type="number"
                          className="input-sm"
                          placeholder="$"
                          value={changes.amount2}
                          onChange={(e) =>
                            this.handleContent('amount2', e.target.value)
                          }
                        />{' '}
                        &nbsp;following the completion and delivery of the
                        services&nbsp;
                      </Radio>
                    </FormGroup>
                  </div>
                </li>
                <li>
                  <FormGroup>
                    The Producer will be paid a royalty of &nbsp;
                    <FormControl
                      type="number"
                      className="input-sm"
                      placeholder="%"
                      value={changes.percentage}
                      onChange={(e) =>
                        this.handleContent('percentage', e.target.value)
                      }
                    />{' '}
                    &nbsp;% of Owner’s Net Receipts from all (check any):
                    <div className="indent-style">
                      <Checkbox
                        name="sales"
                        checked={changes.sales === true}
                        onChange={(e) =>
                          this.handleContent('sales', e.target.checked)
                        }
                      >
                        Sales
                      </Checkbox>
                      <Checkbox
                        name="performances"
                        checked={changes.performances === true}
                        onChange={(e) =>
                          this.handleContent('performances', e.target.checked)
                        }
                      >
                        Performances
                      </Checkbox>
                      <Checkbox
                        name="licenses"
                        checked={changes.licenses === true}
                        onChange={(e) =>
                          this.handleContent('licenses', e.target.checked)
                        }
                      >
                        Licenses
                      </Checkbox>
                      <Checkbox
                        name="any"
                        checked={changes.any === true}
                        onChange={(e) =>
                          this.handleContent('any', e.target.checked)
                        }
                      >
                        Any other exploitations of the Master(s)
                      </Checkbox>
                    </div>
                    <div className="indent-style">
                      <FormGroup>
                        Royalties will be paid and accounted to the Producer
                        over a &nbsp;
                        <Select
                          className="select-mini"
                          value={changes.period}
                          onChange={(e) =>
                            this.handleContent('period', e.target.value)
                          }
                        >
                          <option value="">select</option>
                          <option value="monthly">monthly</option>
                          <option value="quarterly">quarterly</option>
                          <option value="annual">annual</option>
                        </Select>{' '}
                        &nbsp;period within&nbsp;
                        <Select
                          className="select-mini"
                          value={changes.periodDay}
                          onChange={(e) =>
                            this.handleContent('periodDay', e.target.value)
                          }
                        >
                          <option value="">select</option>
                          <option value="30">30</option>
                          <option value="60">60</option>
                          <option value="90">90</option>
                        </Select>
                        &nbsp;days of the end of that period.
                      </FormGroup>
                    </div>
                  </FormGroup>
                </li>
                <li>
                  <FormGroup>
                    The Producer &nbsp;
                    <Select
                      className="select-mini"
                      value={changes.auditType}
                      onChange={(e) =>
                        this.handleContent('auditType', e.target.value)
                      }
                    >
                      <option value="">select</option>
                      <option value="will">will</option>
                      <option value="notWill">will not</option>
                    </Select>{' '}
                    &nbsp;have the right to conduct an audit
                  </FormGroup>
                </li>
              </ul>
            )}

            <Radio
              name="paidType"
              checked={changes.paidType === 2}
              readOnly
              onClick={(e) => this.handleContent('paidType', 2)}
            >
              The Producer will be paid an advance of their royalty from net
              receipts.
            </Radio>
            {changes.paidType === 2 && (
              <ul className="sub-answer">
                <li>
                  <FormGroup>
                    The advance will be of $&nbsp;
                    <FormControl
                      type="number"
                      className="input-sm"
                      placeholder="$"
                      value={changes.amount}
                      onChange={(e) =>
                        this.handleContent('amount', e.target.value)
                      }
                    />
                  </FormGroup>
                  <div className="indent-style">
                    <FormGroup>
                      <Radio
                        name="paySchedule"
                        checked={changes.paySchedule === 0}
                        readOnly
                        onClick={(e) => this.handleContent('paySchedule', 0)}
                      >
                        The Producer will be paid &nbsp;
                        <FormControl
                          type="number"
                          className="input-sm"
                          placeholder="#"
                          value={changes.day}
                          onChange={(e) =>
                            this.handleContent('day', e.target.value)
                          }
                        />
                        &nbsp; days &nbsp;
                        <Select
                          className="select-mini"
                          value={changes.scheduleType}
                          onChange={(e) =>
                            this.handleContent('scheduleType', e.target.value)
                          }
                        >
                          <option value="">select</option>
                          <option value="execution">
                            following the full execution of this agreement
                          </option>
                          <option value="completion">
                            following the completion and delivery of the
                            services
                          </option>
                        </Select>
                      </Radio>
                      <Radio
                        name="paySchedule"
                        checked={changes.paySchedule === 1}
                        readOnly
                        onClick={(e) => this.handleContent('paySchedule', 1)}
                      >
                        The Producer will be paid $&nbsp;
                        <FormControl
                          type="number"
                          className="input-sm"
                          placeholder="$"
                          value={changes.amount1}
                          onChange={(e) =>
                            this.handleContent('amount1', e.target.value)
                          }
                        />{' '}
                        &nbsp;following full execution of this agreement and the
                        balance $&nbsp;
                        <FormControl
                          type="number"
                          className="input-sm"
                          placeholder="$"
                          value={changes.amount2}
                          onChange={(e) =>
                            this.handleContent('amount2', e.target.value)
                          }
                        />{' '}
                        &nbsp;following the completion and delivery of the
                        services&nbsp;
                      </Radio>
                    </FormGroup>
                  </div>
                </li>
                <li>
                  <FormGroup>
                    The Producer will be paid a royalty of &nbsp;
                    <FormControl
                      type="number"
                      className="input-sm"
                      placeholder="%"
                      value={changes.percentage}
                      onChange={(e) =>
                        this.handleContent('percentage', e.target.value)
                      }
                    />{' '}
                    &nbsp;% of Owner’s Net Receipts from all (check any):
                    <div className="indent-style">
                      <Checkbox
                        name="sales"
                        checked={changes.sales === true}
                        onChange={(e) =>
                          this.handleContent('sales', e.target.checked)
                        }
                      >
                        Sales
                      </Checkbox>
                      <Checkbox
                        name="performances"
                        checked={changes.performances === true}
                        onChange={(e) =>
                          this.handleContent('performances', e.target.checked)
                        }
                      >
                        Performances
                      </Checkbox>
                      <Checkbox
                        name="licenses"
                        checked={changes.licenses === true}
                        onChange={(e) =>
                          this.handleContent('licenses', e.target.checked)
                        }
                      >
                        Licenses
                      </Checkbox>
                      <Checkbox
                        name="any"
                        checked={changes.any === true}
                        onChange={(e) =>
                          this.handleContent('any', e.target.checked)
                        }
                      >
                        Any other exploitations of the Master(s)
                      </Checkbox>
                    </div>
                    <div className="indent-style">
                      <FormGroup>
                        Royalties will be paid and accounted to the Producer
                        over a &nbsp;
                        <Select
                          className="select-mini"
                          value={changes.period}
                          onChange={(e) =>
                            this.handleContent('period', e.target.value)
                          }
                        >
                          <option value="">select</option>
                          <option value="monthly">monthly</option>
                          <option value="quarterly">quarterly</option>
                          <option value="annual">annual</option>
                        </Select>{' '}
                        &nbsp;period within&nbsp;
                        <Select
                          className="select-mini"
                          value={changes.periodDay}
                          onChange={(e) =>
                            this.handleContent('periodDay', e.target.value)
                          }
                        >
                          <option value="">select</option>
                          <option value="30">30</option>
                          <option value="60">60</option>
                          <option value="90">90</option>
                        </Select>
                        &nbsp;days of the end of that period.
                      </FormGroup>
                    </div>
                  </FormGroup>
                </li>
                <li>
                  <FormGroup>
                    The Producer &nbsp;
                    <Select
                      className="select-mini"
                      value={changes.auditType}
                      onChange={(e) =>
                        this.handleContent('auditType', e.target.value)
                      }
                    >
                      <option value="">select</option>
                      <option value="will">will</option>
                      <option value="notWill">will not</option>
                    </Select>{' '}
                    &nbsp;have the right to conduct an audit
                  </FormGroup>
                </li>
              </ul>
            )}
          </FormGroup>

          {/* Optional question from ownership Tab */}
          {ownershipBlock &&
            ownershipBlockChanges &&
            ownershipBlockChanges.composition === 1 && (
              <div>
                <div>
                  <b>
                    What percentage of the minimum statutory royalty rate will
                    you pay the Producer for copies of the song sold/downloaded
                    in the U.S.?
                  </b>
                </div>
                <FormGroup style={{ marginLeft: '20px' }}>
                  Percentage of the minimum statutory rate: &nbsp;
                  <FormControl
                    type="number"
                    className="input-sm"
                    placeholder="%"
                    value={changes.statutoryPercentage}
                    onChange={(e) =>
                      this.handleContent('statutoryPercentage', e.target.value)
                    }
                  />
                  &nbsp;%
                </FormGroup>
              </div>
            )}
        </div>
      );
    } else {
      return null;
    }
  }

  renderChangeRequest(changeRequest) {
    const { changes } = changeRequest;
    const joinReceipts = getStringFromArray('payments', changes);

    let content = '';
    if (changes.paidType === 0) {
      content = `<div>The Producer will be paid a rate of $${changes.amount
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${
        changes.feeType === 'perHour' ? 'per hour' : 'in total'
      }.</div>`;
      if (changes.paySchedule === 0) {
        if (changes.scheduleType === 'execution') {
          content += `<div>The Producer will be paid ${changes.day} days following the execution of this agreement.</div>`;
        } else if (changes.scheduleType === 'completion') {
          content += `</div>The Producer will be paid ${changes.day} days following the completion and delivery of the services.</div>`;
        }
      } else if (changes.paySchedule === 1) {
        content += `</div>The Producer will be paid $${changes.amount1
          .toString()
          .replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ','
          )} following full execution of this agreement and the balance $${this.props.amount2
          .toString()
          .replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ','
          )} following the completion and delivery of the services.</div>`;
      }
    } else if (changes.paidType === 1) {
      content = `<div>The Producer will be paid a rate of $${changes.amount
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${
        changes.feeType === 'perHour' ? 'per hour' : 'in total'
      }.</div>`;
      if (changes.paySchedule === 0) {
        if (changes.scheduleType === 'execution') {
          content += `<div>The Producer will be paid ${changes.day} days following the execution of this agreement.</div>`;
        } else if (changes.scheduleType === 'completion') {
          content += `</div>The Producer will be paid ${changes.day} days following the completion and delivery of the services.</div>`;
        }
      } else if (changes.paySchedule === 1) {
        content += `</div>The Producer will be paid $${changes.amount1
          .toString()
          .replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ','
          )} following full execution of this agreement and the balance $${this.props.amount2
          .toString()
          .replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ','
          )} following the completion and delivery of the services.</div>`;
      }
      content +=
        `<div>The Producer will be paid a royalty of ${changes.percentage}% of Owner’s Net Receipts from all ${joinReceipts}.</div>` +
        `<div>Royalties will be paid and accounted to the Producer over a ${changes.period} period within ${changes.periodDay} days of the end of that period.</div>` +
        `<div>The Producer ${changes.auditType} have the right to conduct an audit.</div>`;
    } else if (changes.paidType === 2) {
      content = `<div>The Advance will be of $${changes.amount
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} per master.</div>`;
      if (changes.paySchedule === 0) {
        if (changes.scheduleType === 'execution') {
          content += `<div>The Producer will be paid ${changes.day} days following the execution of this agreement.</div>`;
        } else if (changes.scheduleType === 'completion') {
          content += `</div>The Producer will be paid ${changes.day} days following the completion and delivery of the services.</div>`;
        }
      } else if (changes.paySchedule === 1) {
        content += `</div>The Producer will be paid $${changes.amount1
          .toString()
          .replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ','
          )} following full execution of this agreement and the balance $${this.props.amount2
          .toString()
          .replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ','
          )} following the completion and delivery of the services.</div>`;
      }
      content +=
        `<div>The Producer will be paid a royalty of ${changes.percentage}% of Owner’s Net Receipts from all ${joinReceipts}.</div>` +
        `<div>Royalties will be paid and accounted to the Producer over a ${changes.period} period within ${changes.periodDay} days of the end of that period.</div>` +
        `<div>The Producer ${changes.auditType} have the right to conduct an audit.</div>` +
        `${
          _.findKey(changes.ownershipBlock.changes, 'composition') &&
          changes.ownershipBlock.changes.composition === 1
            ? `<div>Percentage of the minimum statutory rate: ${changes.statutoryPercentage}.</div>`
            : ''
        }`;
    }

    return content;
  }

  renderChangeRequests() {
    return (
      <ChangeRequestsView
        changeRequests={this.props.changeRequests}
        renderChangeRequest={(changeRequest) =>
          this.renderChangeRequest(changeRequest)
        }
        isHTML
      />
    );
  }

  getShortContent() {
    let content = '';

    if (this.props.paidType === 0) {
      content =
        `The Producer will be paid a fee and will not receive a royalty. ` +
        `The Producer will be paid a rate of $${this.props.amount
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${
          this.props.feeType === 'perHour' ? 'per hour' : 'in total'
        }.`;
    } else if (this.props.paidType === 1) {
      content =
        `The Producer will be paid a fee and will receive a royalty of net receipts. ` +
        `The Producer will be paid a rate of $${this.props.amount
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${
          this.props.feeType === 'perHour' ? 'per hour' : 'in total'
        }.`;
    } else if (this.props.paidType === 2) {
      content =
        `The Producer will be paid an advance of their royalty from net receipts. ` +
        `The advance will be of $${this.props.amount
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.`;
    }
    if (this.props.paySchedule === 0) {
      if (this.props.scheduleType === 'execution') {
        content += ` The Producer will be paid ${this.props.day} days following the execution of this agreement.`;
      } else if (this.props.scheduleType === 'completion') {
        content += ` The Producer will be paid ${this.props.day} days following the completion and delivery of the services.`;
      }
    } else if (this.props.paySchedule === 1) {
      content += ` The Producer will be paid $${this.props.amount1
        .toString()
        .replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
        )} following full execution of this agreement and the balance $${this.props.amount2
        .toString()
        .replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
        )} following the completion and delivery of the services.`;
    }
    if (this.props.paidType === 1 || this.props.paidType === 2) {
      content += ` The Producer will be paid a royalty of ${
        this.props.percentage
      }% of Owner’s Net Receipts from all ${getStringFromArray(
        'payments',
        this.props
      )}.`;
      content += ` Royalties will be paid and accounted to the Producer over a ${this.props.period} period within ${this.props.periodDay} days of the end of that period.`;
      content += ` The Producer ${
        this.props.auditType === 'will' ? 'will' : 'will not'
      } have the right to conduct an audit.`;
    }
    if (this.props.statutoryPercentage !== '') {
      content += ` The Producer will be paid ${this.props.statutoryPercentage}% of the minimum statutory rate for copies sold/downloaded in the U.S.`;
    }
    return content;
  }

  render() {
    const { adjust, block } = this.state;

    return (
      <div className="tab-content payment-tab">
        <Row>
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>
              <p className="question">How will the Producer Be Paid?</p>
              <FormGroup className="answer">
                <Radio
                  name="contribution-adjust"
                  checked={adjust === false}
                  readOnly
                  onClick={(e) =>
                    block && adjust === undefined
                      ? {}
                      : this.handleAdjust(false)
                  }
                  disabled={block && adjust === undefined}
                >
                  {this.props.userInfo.same
                    ? `Keep my original proposal: `
                    : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                  {this.getShortContent()}
                </Radio>
                <hr />
                <Radio
                  name="contribution-adjust"
                  checked={adjust === true}
                  readOnly
                  onClick={(e) => this.handleAdjust(true)}
                >
                  {this.props.userInfo.same
                    ? `Change my proposal:`
                    : `Suggest an alternative:`}
                </Radio>
                {this.renderAdjust()}
              </FormGroup>
              {this.props.renderAccepts()}
              {this.renderChangeRequests()}
            </Col>
          )}
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>{this.props.children}</Col>
          )}

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  Producers should be compensated for the work that they have
                  done. This section defines what that payment will be and when
                  it will be paid to the Producer for their work.
                </p>
              </div>
              <div className="expand" tabIndex="1">
                <p className="question">What are "net receipts"?</p>
                <p className="small">
                  Net receipts are the total funds generated by the master(s)
                  that the Owner receives, minus the Owner’s expenses relating
                  to recording the master(s) and the cost of manufacturing,
                  distributing, and union payments that were incurred relating
                  to records that the master appears on.
                </p>
              </div>
              <div className="expand" tabIndex="2">
                <p className="question">What is an "advance"?</p>
                <p className="small">
                  An “advance” is an upfront payment of money that is offset in
                  the future by royalties or other types of income.
                </p>
              </div>
              <div className="expand" tabIndex="3">
                <p className="question">What does "recoup" mean</p>
                <p className="small">
                  “Recoup” is short for “recuperation” and means to be
                  compensated for something that has been paid out, such as an
                  advance of money.
                </p>
              </div>
              <div className="expand" tabIndex="4">
                <p className="question">
                  What is the minimum statutory royalty rate?
                </p>
                <p className="small">
                  Sound Recordings are created from musical compositions. When a
                  Producer owns a share of the musical composition(s), they are
                  entitled to a statutory royalty called a “mechanical royalty.”
                  The amount of the royalty is fixed by the Copyright Royalty
                  Board and that fixed amount is owed to the Producer every time
                  a sound recording that contains their composition is
                  reproduced (streamed, sold, downloaded). You can propose to
                  pay the Producer the full (100%) amount of that royalty, or
                  you can propose to pay some lesser percentage of it.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/DealContractBlock/Payments.jsx